import script from "./FechamentoDiario.vue?vue&type=script&setup=true&lang=js"
export * from "./FechamentoDiario.vue?vue&type=script&setup=true&lang=js"

import "./FechamentoDiario.vue?vue&type=style&index=0&id=bb1f845c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bb1f845c"]])

export default __exports__